import { React, useEffect, useState } from "react";
import { FiArrowDown, FiArrowUpRight } from "react-icons/fi";
import Navbar from "../Components/Navbar";
import { Avtar_img } from "../Assets";
import { motion } from "framer-motion";
import HeroTitle from "../Components/HeroTitle";
import Profilepic from "../Assets/Profile-pic.jpeg"
import { Link, useNavigate } from "react-router-dom";
import ProjectShowCase from "./.Projects/ProjectShowCase";
// import star_shape from "../../Assets/index"

const Hero = () => {
  const [visibleIndex, setVisisbleindex] = useState(0);
  const [experience, setExperience] = useState();
  const navigate = useNavigate();

  let startDate = "26-01-2023"

  useEffect(() => {
    const interval = setInterval(() => {
      setVisisbleindex((prevIndex) => (prevIndex + 1) % 3);
    }, 2300);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const calculateExperience = () => {
      // Split the date string in DD-MM-YYYY format
      const [day, month, year] = startDate.split('-').map(Number);

      // Create a new Date object with the parsed values
      const start = new Date(year, month - 1, day);
      const now = new Date();

      let years = now.getFullYear() - start.getFullYear();
      let months = now.getMonth() - start.getMonth();

      // Adjust if the current month is before the start month
      if (months < 0) {
        years--;
        months += 12;
      }

      // Calculate the total experience in years as a decimal value
      const totalYears = years + months / 12;

      // Round the total years to the nearest integer
      const roundedYears = Math.round(totalYears);


      setExperience(roundedYears);
    };

    calculateExperience();
  }, []);

  const handleNavigate = (link) => {
    navigate(link)
  }

  return (
    <>
      <div className="app-main-wrapper">
        <Navbar />
        <div className="Hero-section-main-wrapper">
          <div className="hero-main-section">
            <div className="container">
              <div className="hero-box-cover">
                <div className="row d-flex align-items-center justify-content-center">
                  <div className="col-lg-5">
                    <div className="projects-button-wrapper-box">
                      <div className="row">
                        <div className="col-lg-8 col-8">
                          <div className="row">
                            <div className="col-lg-6 col-6 p-0">
                              <motion.div className="project-first-btn-box d-flex flex-column"
                                initial={{ opacity: 0, scale: 0.5, width: 0 }}
                                animate={{
                                  opacity: 1,
                                  scale: 1,
                                  width: "88%",
                                }}
                                transition={{ duration: 0.4, delay: 0.5 }}
                              >
                                <motion.div
                                  className="hero-about-section-btn hero-box"
                                  initial={{ opacity: 0, scale: 0.5 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.3, delay: 0.9 }}
                                  onClick={() => handleNavigate('/about')}
                                >
                                  <h6 className="About-btn">About Us</h6>
                                </motion.div>
                                <div className="project-download-btb-box">
                                  <FiArrowDown />
                                  <h6>Download CV</h6>
                                </div>
                              </motion.div>
                            </div>
                            <div className="col-6 p-0">
                              <div className="project-second-btn-box d-flex flex-column">
                                <motion.div
                                  initial={{ opacity: 0, scale: 0.5, width: 0 }}
                                  animate={{
                                    opacity: 1,
                                    scale: 1,
                                    width: "86%",
                                  }}
                                  transition={{ duration: 0.3, delay: 0.4 }}
                                  className="experience-btn-box"
                                >
                                  <h5>{experience} </h5>
                                  <p>Years of experience</p>
                                </motion.div>
                                <motion.div
                                  className="stylish-bg"
                                  initial={{ opacity: 0, scale: 0.5, width: 0 }}
                                  animate={{
                                    opacity: 1,
                                    scale: 1,
                                    width: "84%",
                                  }}
                                  transition={{ duration: 0.3, delay: 0.6 }}
                                ></motion.div>
                              </div>
                            </div>
                            <div className="col-lg-12 p-0">
                              <motion.div
                                className="our-service-btn-box-wrapper d-flex align-items-center"
                                initial={{ opacity: 0, scale: 0.5, width: 0 }}
                                animate={{
                                  opacity: 1,
                                  scale: 1,
                                  width: "96%",
                                }}
                                transition={{ duration: 0.3, delay: 0.5 }}
                              >
                                <motion.div
                                  className="Our-service"
                                  initial={{ opacity: 0, scale: 0.5 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.3, delay: 0.9 }}
                                >
                                  <FiArrowUpRight />
                                </motion.div>
                                <div className="our-service-letter">
                                  <h5 className="mx-3">Services</h5>
                                </div>
                              </motion.div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4  col-4 p-0">
                          <div className="last-profile-box-cover" onClick={() => handleNavigate('/projects')}>
                            <motion.div
                              className="profile-box"
                              initial={{ opacity: 0, scale: 0.5, width: 0 }}
                              animate={{ opacity: 1, scale: 1, width: "88%" }}
                              transition={{ duration: 0.4, delay: 0.3 }}
                            >
                              <img src={Profilepic}></img>
                            </motion.div>
                            <motion.div
                              initial={{ opacity: 0, width: 0 }}
                              animate={{ opacity: 1, width: "88%" }}
                              transition={{ duration: 0.6, delay: 0.4 }}
                              className="our-portfolio-btn-box"
                            >
                              <p>My Projects</p>
                            </motion.div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <div className="content">
                      <h5 className="cd-headline slide">
                        <span>Hello, I’m</span>
                        <span
                          className="cd-words-wrapper main-color"
                          style={{ width: "239.953px" }}
                        >
                          <b
                            className={
                              visibleIndex === 0 ? "is-visible" : "is-hidden"
                            }
                          >
                            Khan Maheeb
                          </b>
                          <b
                            className={
                              visibleIndex === 1 ? "is-visible" : "is-hidden"
                            }
                          >
                            Software Developer
                          </b>
                          <b
                            className={
                              visibleIndex === 2 ? "is-visible" : "is-hidden"
                            }
                          >
                            Front-End Developer
                          </b>
                          <b
                            className={
                              visibleIndex === 3 ? "is-visible" : "is-hidden"
                            }
                          >
                            ReactJs Developer
                          </b>
                        </span>
                      </h5>
                      <HeroTitle data="I’m a Front-end Developer and UI Developer Based in Mumbai." />
                      <p className="text">
                        Software Developer with 2 years of experience building high-performance web and mobile applications from scratch for startups. Based in Mumbai, I specialize in creating dynamic, responsive, and user-focused solutions using React.js and modern technologies tailored to meet real-world needs.
                      </p>
                      <div className="stauts mt-4 pt-4 bord-thin-top">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="ml-auto">
                            <div className="butn-presv">
                              <Link
                                to="https://calendly.com/maheebmedibhai/30min"
                                className="butn butn-md butn-bord radius-5 skew text-decoration-none"

                              >
                                <span>Contact Me</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProjectShowCase />
      </div>
    </>
  );
};

export default Hero;
